import {FACTIONS} from "../../../constants/factions";
import {isPreW39FactionPlayer} from "../abTestGates";

// Фракции волны 39: до нее ботам запрещены (configs/botExcludedFactions), общий
// код ботов их механик не знал
export const W39_FACTIONS = [FACTIONS.GIANTS, FACTIONS.SUCCUBES, FACTIONS.GOBLINS];

/**
 * Играет ли игрок фракционной игрой волны 39 за фракцию factionId: его фракция
 * совпадает и он не в legacy-наборе A/B (isPreW39FactionPlayer). Legacy-игрок
 * этих фракций играет общим кодом ботов, как до волны
 */
export const checkIfW39FactionPlay = (player, factionId) => Boolean(player)
  && player.factionId === factionId
  && !isPreW39FactionPlayer(player.id);

/**
 * То же по отряду: фракция отряда (не владельца — соблазненный суккубами отряд
 * сохраняет фракцию и ее правила) и гейт его владельца
 */
export const checkIfW39FactionUnit = (unit, factionId) => Boolean(unit)
  && unit.factionId === factionId
  && !isPreW39FactionPlayer(unit.ownerId);
